<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ topTravel.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>

        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'TopTravelForm',

  props: {
    topTravel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.topTravel),

      sortOptions: [...Array(10).keys()].map(i => i + 1)
    }
  },
  validations: {
    form: {
      sort: { required },
      status: { required },
      name: { required, maxLength: maxLength(50) }
    }
  },
  computed: {
    formTitle() {
      let title = this.topTravel.id
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.top_travel')

      return title
    },
    isLoading() {
      return this.sending
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        sort: data.sort,
        status: data.status,
        name: data.name
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
